import { ERROR_CODES as MFE_ERROR_CODES } from "diagnostics-domain/manualFaultEvent/error_types";
import type { ManualFaultEventErrorCode } from "diagnostics-domain/manualFaultEvent/error_types";

export const enValidations = {
  manualFaultEvents: (code: ManualFaultEventErrorCode | undefined): string | undefined => {
    if (!code) {
      return undefined;
    }

    switch (code) {
      case MFE_ERROR_CODES.NAME_EMPTY:
        return "Event name cannot be empty";
      case MFE_ERROR_CODES.NAME_ALREADY_EXISTS:
        return "An event with the same name already exists";
      case MFE_ERROR_CODES.NAME_TOO_LONG:
        return "The name cannot exceed 100 characters";
      case MFE_ERROR_CODES.START_DATE_EMPTY:
        return "Start date is required";
      case MFE_ERROR_CODES.START_DATE_AFTER_SECOND_WINDOW:
        return "The start date must be before the next period start date";
      case MFE_ERROR_CODES.START_DATE_AFTER_EVENT_END:
        return "Start date must be before end date";
      case MFE_ERROR_CODES.START_DATE_NOT_IN_PROJECT_PERIOD:
        return "The start date must be between the first and last data point linked to the data source";
      case MFE_ERROR_CODES.CLOSE_DATE_EMPTY:
        return "The end date is required";
      case MFE_ERROR_CODES.CLOSE_DATE_BEFORE_LAST_IMPACT_WINDOW:
        return "End date must be after the beginning of the last time window";
      case MFE_ERROR_CODES.CLOSE_DATE_NOT_IN_PROJECT_PERIOD:
        return "The end date must be between the start date and the end date of the data source";
      case MFE_ERROR_CODES.ACTION_TOO_LONG:
        return "The action identified field cannot exceed 4000 characters";
      case MFE_ERROR_CODES.DESCRIPTION_TOO_LONG:
        return "The description cannot exceed 4000 characters";
      case MFE_ERROR_CODES.OVERLAPPING_EVENT_EXISTS:
        return "An event already exists during this period";
      case MFE_ERROR_CODES.NO_ACTIVE_ANALYSIS:
        return "At least one active analysis is required to create or edit a manual event";
      default:
        return "An unexpected error occurred.";
    }
  },
};
